import { createBrowserHistory } from 'history';
import env from './env';

export const history = createBrowserHistory({ basename: env.basename });
